<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengList"
      data-title="报名信息"
    >
      <el-button
        type="primary"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        保存修改
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
        
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {});
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
